export enum ModalTypes {
    Create = 'create',
    Edit = 'edit'
  }
